import React from 'react';
import PropTypes from "prop-types";
import axios from 'axios';
import Spinner from "../../../qwc2/components/widgets/Spinner";
import LocaleUtils from "../../../qwc2/utils/LocaleUtils";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import CoordinatesUtils from "qwc2/utils/CoordinatesUtils";
import isEmpty from "lodash.isempty";
import geojsonBbox from "geojson-bounding-box";

class PoiTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        map: PropTypes.object,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            bus_stop: {
                isLoading: true,
                data: []
            },
            kindergarten: {
                isLoading: true,
                data: []
            },
            school: {
                isLoading: true,
                data: []
            },
            supermarket: {
                isLoading: true,
                data: []
            },
            amenities: {
                isLoading: true,
                data: []
            }
        };
    }

    getCenter(feature) {
        let bounds = null;
        if (feature.properties.geometry) {
            bounds = feature.properties.geometry.getExtent();
            bounds = CoordinatesUtils.reprojectBbox(bounds, this.props.map.projection, 'EPSG:4326');
        } else {
            bounds = geojsonBbox(feature);
        }
        return [0.5 * (bounds[0] + bounds[2]), 0.5 * (bounds[1] + bounds[3])];
    }

    getPoisByType = (poiType) => {
        let center;
        try {
            center = this.getCenter(this.props.feature);
        } catch (error) {
            // e.g. an object without geometry
            console.log("POIs: no position for the object *** : " + error);
            this.setState({[poiType]: {data: [], isLoading: false}});
            return;
        }
        const srcX = center[0];
        const srcY = center[1];

        let limit = 30;
        const srsEpsg = '4326';

        let posTypeStr = 'amenities?';

        switch (poiType) {
            case 'bus_stop':
                posTypeStr = 'busstop?';
                limit = 3;
                break;
            case 'kindergarten':
                posTypeStr = 'kindergarten?';
                limit = 3;
                break;
            case 'school':
                posTypeStr = 'school?';
                limit = 3;
                break;
            case 'supermarket':
                posTypeStr = 'shop?shop=supermarket&';
                limit = 3;
                break;
        }

        let url = `https://poi.immospector.com/mapPoiService/poi/${posTypeStr}srcSrs=${srsEpsg}&srcX=${srcX}&srcY=${srcY}&limit=${limit}`;
        //url = `http://geo.web3.abelmann.net/proxy/4/${posTypeStr}srcSrs=${srsEpsg}&srcX=${srcX}&srcY=${srcY}&limit=${limit}`;
        const self = this;

        axios(url).then(response => {
            const newState = {};
            newState[poiType] = {
                data: response.data,
                isLoading: false
            };
            self.setState(newState);
        }).catch(error => {
            console.log("Error *** : " + error);
            self.setState({[poiType]: {data: [], isLoading: false}});
        });
    }

    componentDidMount() {
        this.getPoisByType('bus_stop');
        this.getPoisByType('kindergarten');
        this.getPoisByType('school');
        this.getPoisByType('supermarket');
        this.getPoisByType('amenities');
    }

    render() {
        return (
            <div className="feature-details-pois">
                {this.renderType('bus_stop')}
                {this.renderType('kindergarten')}
                {this.renderType('school')}
                {this.renderType('supermarket')}
                {this.renderType('amenities')}
            </div>
        );
    }

    renderType(type) {
        return (
            <div className="feature-details-poi">
                <h5>{LocaleUtils.tr("poitype." + type)}</h5>
                {this.state[type].isLoading &&
                    <div>
                        <Spinner/>
                        <div>{LocaleUtils.tr("attribtable.loading")}</div>
                    </div>
                }
                {!this.state[type].isLoading &&
                    <div>
                        {this.renderData(type, this.state[type].data)}
                    </div>
                }
            </div>
        );
    }

    renderPoi(poi, showType) {
        const key = "poi" + poi.poi_type + "-" + poi.name;

        let iconName = poi.poi_type || poi.shop;
        switch(iconName) {
            case 'bus_stop':
                iconName = 'busstop';
                break;
        }
        const icon = 'https://osmgs.immospector.com/geoserver/osm/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&STRICT=false&TRANSPARENT=true&style=' + iconName;
        return (
            <div className="poi-item" key={key}>
                <img src={icon}/>
                {showType &&
                    <span>
                    {LocaleUtils.tr("poitype." + poi.poi_type)}
                </span>
                }
                {poi.name &&
                    <span>
                    {poi.name}
                </span>
                }
                <strong>{poi.dist}m</strong>
            </div>
        );
    }

    renderData(poitype, data) {
        let showType = false;
        // the service may answer with something else than a list of pois (error, empty result)
        let pois = Array.isArray(data?.poi) ? data.poi.filter(Boolean) : [];
        if (poitype == 'amenities') {
            pois = pois.filter(poi => ["bus_stop", "kindergarten", "school", "supermarket"].indexOf(poi.poi_type) == -1);
            showType = true;
        }
        if (isEmpty(pois)) {
            return (
                <div>-</div>
            );
        }
        return (
            <div>
                {pois.map(p => this.renderPoi(p, showType))}
            </div>
        );
    }
}

const selector = (state) => ({
    map: state.map
});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
})(PoiTab);
